<template>
    <div class="contentHolderGroup">
        
        <div class="formHolder">
            <Input name="Email address" placeholder="Email address" v-model="item.email" :error="errors.email"/>
        </div>

        <div class="actionButtons">
            <button class="default medium" @click="handleProfileUpdate" :disabled="isLoading(['handleProfileUpdate'])">{{ isLoading(['handleProfileUpdate']) ? 'Saving' : 'Save changes' }}</button>
        </div>
        
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

    export default {
        data() {
            return {
                item: {},
                errors: {}
            }
        },
        computed: {
            ...mapGetters(['user'])
        },
        watch: {
            user: {
                deep: true,
                handler() {
                    this.item = {
                        email: this.user.credentials.email
                    }
                }
            }
        },
        methods: {
            handleProfileUpdate() {
                this.errors = {}
                this.ajax('handleProfileUpdate', {
                    url: '/email',
                    method: 'PUT',
                    data: this.item
                }, (err, body) => {
                    if(err) {
                        if(body.errors) this.errors = body.errors;
                        else alert(body.message || 'Something went wrong. Please, try again!');
                        return;
                    }
                    this.$emit('updateProfile');
                    this.$notify({
                        type: 'info',
                        text: `Your email address has been changed.`
                    });
                });
            }
        },
        mounted() {
            this.item = {
                email: this.user.credentials.email
            }
        }
    }
</script>

<style lang="scss" scoped>
.contentHolderGroup {
    display: grid;
    row-gap: 20px;
}

.formHolder {
    display: grid;
    row-gap: 15px;
}

.actionButtons {
    display: grid;
    justify-content: end;
}
</style>